import fetchSmimeDataPackage from './fetchSmimeDataPackage';
import ISmimeAdapter from 'owa-smime-adapter/lib/adapter/ISmimeAdapter';
import SmimeMessage from 'owa-smime-adapter/lib/store/schema/SmimeMessage';
import SmimeResult from 'owa-smime-adapter/lib/store/schema/SmimeResult';
import getSmimeAttachmentURL from '../utils/getSmimeAttachmentURL';
import SmimeCustomError from '../utils/SmimeCustomError';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { isSmimeAttachmentType } from 'owa-attachment-model-store';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

/**
 * Fetch the SMIME p7m data package and return the decoded message
 */
export default async function fetchAndDecodeSmimeMessage(
    smimeAttachment: AttachmentType,
    mailboxId: string,
    adapter: ISmimeAdapter
): Promise<SmimeMessage> {
    if (!(smimeAttachment && mailboxId && adapter)) {
        return null;
    }
    let p7mFile: string;
    if (isSmimeAttachmentType(smimeAttachment)) {
        p7mFile = smimeAttachment.Content;
    } else {
        const url = getSmimeAttachmentURL(mailboxId, smimeAttachment.AttachmentId);
        p7mFile = await fetchSmimeDataPackage(url);
    }
    const createMessageDatapoint = new PerformanceDatapoint('CreateMessageFromSmime', {
        isCore: true,
    });
    const smimeResult: SmimeResult = await adapter.createMessageFromSmimeAsync(p7mFile);

    if (smimeResult.ErrorCode !== SmimeErrorStateEnum.NoError) {
        createMessageDatapoint.endWithError(
            DatapointStatus.ClientError,
            new Error(smimeResult.ErrorCode && smimeResult.ErrorCode.toString())
        );
        throw new SmimeCustomError('S/MIME could not be decoded.', smimeResult.ErrorCode);
    } else {
        createMessageDatapoint.end();
    }
    return <SmimeMessage>smimeResult.Data;
}
